module.exports = __webpack_public_path__ + "assets/img/4138cbe935db14aba3c07a7cf36b1f68.svg";